<template>
    <div class="Poster">
        <Header msg="长按保存二维码"/>
        <!-- <div class="Poster-box">
            <img :src="poster" class="Poster-img"/>
            <img src="@/assets/recruit/bg@3x.png"/>
            <div class="flex flex-a-i-center invi-box">
                <img :src="invi.avatar_url" class="invi_avatar" />
                <div class="invi-box-right">
                    <p>您的好友 <span style="color:#FABF01">{{invi.true_name || invi.nickname}}</span></p>
                    <p>邀请您一起提升学历</p>
                </div>
            </div>
            <img :src="poster" :class="isloading ? 'Poster-imgs':''" class="qrcode-img" :style="tabH"/>
        </div> -->
        
        <img :src="poster" :class="isloading ? 'Poster-imgs':'Poster-img'" :style="tabH" id="pos"/>
        <div class="poster-bottom">
          <div class="tips">保存图片，分享给学生</div>
          <!-- <div class="flex flex-j-c-sb">
            <p class="poster-p ellipsis-more">{{context}}</p>
            <div class="poster-btn" @click="copyChannel(context)">复制</div>
          </div> -->
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import { previewQrcode, REQUEST_BASE } from '@/api';
import { Toast } from 'mint-ui';

export default {
    name: 'PreviewPay',
    components: {
      Header
    },
    data() {
      return {
        tabH: '', // 图片样式
        poster: require('@/assets/loading.gif'), // 默认海报图
        isloading: true, // 是否加载
        id: 0, // 订单ID
        sessionData:{}, // 缓存数据
        invi: {} // 邀请人信息x
      }
    },
    created() {
      this.sessionData = JSON.parse(sessionStorage.getItem('_sessionData'));
      if (this.sessionData && this.sessionData.RecruitIndex) this.invi = JSON.parse(this.sessionData.RecruitIndex);
      this.id = this.$route.query.pid || '';
      if (!this.id) {
        Toast({message: '该订单不存在，请稍后重试！', className: 'iconfont icon-close'});
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      }
    },
    mounted() {
      let he = document.body.clientHeight, botHe = document.getElementsByClassName('poster-bottom'),wi = document.body.clientWidth;
      // this.tabH = `height:${he - 44}px`;
      this.posterImg();
    },
    methods: {
      // 获取海报
      posterImg() {
        let url = Number(this.$route.query.type) === 1 ? `${REQUEST_BASE()}/Pay?previewId=${this.id}` : `${REQUEST_BASE()}/Confirmation?previewId=${this.id}`
        previewQrcode({
          url: url,
          [Number(this.$route.query.type) === 1 ? 'order_no' : 'preview_id']: this.id,
          type: this.$route.query.type || 1
        }).then(res => {
          if (res.code === 0) {
            this.poster = res.data;
          } else {
            Toast({message: res.msg, className: 'iconfont icon-close'});
            this.isloading = false;
          }
        }).catch(() => {
          // 接口报错时别让页面一直停在加载动画上（原来 500 会永远转圈）
          this.isloading = false;
        })
      },
      // 海报处理
      loadImg() {
        let that = this;
        var img_url = this.poster;
        var img = new Image();
        img.src = img_url;
        let he = document.body.clientHeight, botHe = document.getElementsByClassName('poster-bottom'), wi = document.body.clientWidth;
        img.onload = function() {
          let imgW = wi*0.9;
          let imgH = img.height / (img.width / imgW);
          if (imgH > (he - botHe[0].clientHeight - 44)) {
            imgH = (he - botHe[0].clientHeight - 44) * 0.95;
            imgW = img.width / (img.height / imgH);
          };
          if (imgW > (wi*0.9)) {
            imgH = (he - botHe[0].clientHeight - 44) * 0.95;
            imgW = wi*0.9;
          };
          let imgTOP = (he - botHe[0].clientHeight - 44 - imgH) * 0.5 + 44;
          that.tabH = `width:${imgW}px;height:${imgH}px;top:${imgTOP}px`;
          that.isloading = false;
        }
      },
    },
    watch: {
      poster(n, o) {
        let that = this;
        that.$nextTick(function () {
          that.loadImg();
        })
      }
    }
}

</script>
<style lang='less' scoped>
.Poster{
    height: 100vh;
    width: 100%;
    font-size: 0;
    background: #eee;
    top: 0;
    left: 0;
    .mint-header{
      height: 44px;
    }
    .Poster-box{
        width: 100%;
        height: 100%;
        padding-top: 44px;
        img{
            width: 100%;
            height: 100%;
        }
        .invi-box{
            position: absolute;
            left: 0.16rem;
            top: 0.60rem;
            .invi_avatar{
                width: 0.4rem;
                height: 0.4rem;
                border-radius: 50%;
            }
            .invi-box-right{
                color: #fff;
                font-size: 0.12rem;
                text-align: left;
                margin-left: 0.13rem;
            }
        }
        // .qrcode-img{
        //     width: 2.6rem;
        //     height: 2.6rem;
        //     position: absolute;
        //     left: 50%;
        //     transform: translateX(-50%);
        //     top: 2.4rem;
        // }
        .qrcode-img{
          width: 100%;
          height: auto;
        }
        .Poster-imgs{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          border-radius: 6px;
          box-shadow: 0 7px 12px 0 rgba(0, 0, 0, 0.2);
          width: 3rem!important;
          height: 2.28rem!important;
        }
    }
    .Poster-img{
      width: 85%;
      height: auto;
      position: absolute;
      border-radius: 6px;
      box-shadow: 0 7px 12px 0 rgba(0, 0, 0, 0.2);
      left: 50%;
      transform: translateX(-50%);
    }
    .Poster-imgs{
      position: absolute;
      left: 50%;
      transform: translate(-50%,-50%);
      border-radius: 6px;
      box-shadow: 0 7px 12px 0 rgba(0, 0, 0, 0.2);
      width: 3rem;
      height: 2.28rem;
      top: 50%;
    }
    .poster-bottom{
      position: absolute;
      bottom: 0;
      left: 0;
      // height: 0.8rem;
      width: 100%;
      background: white;
      .tips{
        background: rgb(70, 211, 70);
        color: white;
        width: 100%;
        height: 0.3rem;
        line-height: 0.3rem;
        font-size: 0.12rem;
      }
      .poster-p{
        width: 80%;
        text-align: left;
        font-size: 0.14rem;
        padding: 0.05rem 0.1rem;
        -webkit-line-clamp: 2;
        height: 0.47rem;
        line-height: 0.2rem;
        color: #999;
      }
      .poster-btn{
        margin: 0.1rem 0.1rem;
        width: 0.6rem;
        height: 0.3rem;
        line-height: 0.3rem;
        color: rgb(70, 211, 70);
        border: 1px solid rgb(70, 211, 70);
        border-radius: 0.2rem;
        font-size: 0.14rem;
      }
    }
}
</style>